import React, { useState } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ROIPlaybookModal } from '@/components/modals/ROIPlaybookModal';

export const Layout = ({ children }) => {
  const [isROIModalOpen, setIsROIModalOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Header onOpenROIModal={() => setIsROIModalOpen(true)} />
      
      {/* Main content with padding for fixed header */}
      <main className="flex-grow pt-[104px] md:pt-[112px]">
        {children}
      </main>
      
      <Footer />
      
      {/* ROI Playbook Modal */}
      <ROIPlaybookModal 
        isOpen={isROIModalOpen} 
        onClose={() => setIsROIModalOpen(false)} 
      />
    </div>
  );
};

export default Layout;
